import React from "react";

const Select = ({
  className,
  style,
  onClick,
  onDoubleClick,
  onMouseOver,
  onMouseOut,
  children,
  layerRef
}) => {
  return (
    <select
      ref={layerRef}
      className={className}
      style={style}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {children}
    </select>
  );
};

export default Select;
